import { PayloadAction } from '@reduxjs/toolkit';
import { Source } from 'src/types';
import { CompleteMessageStream } from './message';

type AddSourceAction = PayloadAction<
	{
		messageId: string;
		sources: Source[];
	},
	'source/add'
>;

type AddSourceInternetAction = PayloadAction<
	{
		messageId: string;
		internetSources: Source[];
	},
	'source/add-internet'
>;

type RemoveAllSourceAction = PayloadAction<undefined, 'source/remove-all'>;

export type SourceActions = AddSourceAction | RemoveAllSourceAction | CompleteMessageStream | AddSourceInternetAction;

export const handleAddSources = (messageId: string, sources: Source[]): AddSourceAction => ({
	type: 'source/add',
	payload: { messageId, sources }
});

export const handleAddInternetSources = (messageId: string, internetSources: Source[]): AddSourceInternetAction => ({
	type: 'source/add-internet',
	payload: { messageId, internetSources }
});

export const handleRemoveSources = (): RemoveAllSourceAction => ({
	type: 'source/remove-all',
	payload: undefined
});
